import { firstDayOfMonth } from '../../service/dates';

// Rango con que abre el Kardex (H68): desde el día 1 del mes, sin fecha final. Antes la
// fecha inicial era `new Date()`, la hora actual, y lo de hoy anterior a ese instante no salía.
export function kardexDefaultRange(now = new Date()) {
    return { initialDate: firstDayOfMonth(now), finalDate: null };
}
